import { Box, Container, Grid, Typography, Chip, Card, CardContent } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Link } from 'react-router-dom'
import type { ElementType } from 'react'

export interface SolutionStackItem {
    Icon: ElementType
    tag: string
    title: string
    body: string
    link: string
    linkLabel: string
}

export function SolutionStack({ subtitle, items, color }: {
    subtitle: string
    items: SolutionStackItem[]
    color: string
}) {
    return (
        <Box sx={{ backgroundColor: 'white', py: { xs: 6, md: 10 } }}>
            <Container maxWidth="lg">
                <Typography variant="h2" sx={{ textAlign: 'center', mb: 2 }}>The recommended solution</Typography>
                <Typography color="text.secondary" sx={{ textAlign: 'center', mb: 8, maxWidth: 560, mx: 'auto' }}>
                    {subtitle}
                </Typography>
                <Grid container spacing={4}>
                    {items.map((item, i) => (
                        <Grid item xs={12} md={4} key={item.title}>
                            <Card variant="outlined" component={Link} to={item.link} sx={{
                                height: '100%',
                                display: 'block',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                borderColor: 'rgba(0,0,0,0.2)',
                                transition: 'all 0.25s ease',
                                '&:hover': {
                                    borderColor: color,
                                    boxShadow: `0 8px 32px ${color}30`,
                                    transform: 'translateY(-4px)',
                                },
                            }}>
                                <CardContent sx={{ p: 4, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2.5 }}>
                                        <Box sx={{
                                            width: 48, height: 48, borderRadius: 2,
                                            backgroundColor: `${color}12`,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            flexShrink: 0,
                                        }}>
                                            <item.Icon sx={{ color, fontSize: 24 }} />
                                        </Box>
                                        <Typography sx={{ color: `${color}78`, fontWeight: 800, fontSize: '40px', lineHeight: 1 }}>
                                            {i + 1}
                                        </Typography>
                                    </Box>
                                    <Chip label={item.tag} size="small" sx={{
                                        alignSelf: 'flex-start', mb: 1.5,
                                        backgroundColor: `${color}10`, color,
                                        border: `1px solid ${color}30`,
                                        fontWeight: 600, fontSize: '11px',
                                    }} />
                                    <Typography variant="h5" sx={{ mb: 1.5 }}>{item.title}</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, flex: 1 }}>
                                        {item.body}
                                    </Typography>
                                    <Box sx={{
                                        mt: 3, display: 'inline-flex', alignItems: 'center', gap: 0.5,
                                        color, fontSize: '13px', fontWeight: 600,
                                    }}>
                                        {item.linkLabel} <ArrowForwardIcon sx={{ fontSize: 14 }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}
